module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACISURBVHgBvVCxDYAgEHx1EQsG0DXonERH0U2sIE6hPYWUti4AHokFki+g8RLywN/dX56IgZTSh8P1aipEsaCKYswoI0fy3i9a6+kjeEU7SpfwD6VUz0Zyzg1ws5GzDX9spGhKmLC/zx7uR9xvUoEx5hJC3LhuyL3S76iQ+URtM/m2xiYoF4H7AMZjNTUL8A3hAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/form-data/import-small.png
// module id = T/c6
// module chunks = 46